export function wrapPatient(patient, bundle) {
  return {
    ...patient,
    getManagingOrganization: () =>
      bundle?.resolve(patient, patient?.managingOrganization?.reference),
  };
}
